
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";

const ActivitySection = () => {
  const activities = [
    { property: "Seaside Luxury Villa", event: "New inquiry received", time: "2 hours ago" },
    { property: "Downtown Apartment", event: "Property viewed", time: "5 hours ago" },
    { property: "Mountain Retreat", event: "Viewing scheduled", time: "Yesterday" },
    { property: "Seaside Luxury Villa", event: "Property viewed", time: "Yesterday" },
    { property: "Downtown Apartment", event: "New inquiry received", time: "2 days ago" },
  ];

  return (
    <Card className="lg:col-span-2">
      <CardHeader>
        <CardTitle>Recent Property Activity</CardTitle>
        <CardDescription>Latest views and inquiries for your properties</CardDescription>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          {activities.map((activity, i) => (
            <div key={i} className="flex items-start pb-4 last:pb-0 border-b last:border-0 border-gray-100">
              <div className="flex-1">
                <h4 className="text-sm font-medium">{activity.property}</h4>
                <p className="text-sm text-muted-foreground">{activity.event}</p>
              </div>
              <time className="text-xs text-muted-foreground">{activity.time}</time>
            </div>
          ))}
        </div>
      </CardContent>
      <CardFooter>
        <Button variant="outline" className="w-full">View All Activity</Button>
      </CardFooter>
    </Card>
  );
};

export default ActivitySection;
